import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPsfSharePageData } from './api';
import type { PsfSharePageDataErrorCode } from './types';

export const {
	Context: PsfSharePageDataContext,
	Provider: PsfSharePageDataContextProvider,
	useContext: usePsfSharePageData,
	useAsyncData: usePsfSharePageDataFromApi,
	prefetchAsyncData: prefetchPsfSharePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PsfSharePageDataContext',
	dataProperty: 'pageData',
	getData: getPsfSharePageData,
	getUniqueId: (slug, { queryParams: { share, skip } }) => [slug, share || '', skip || ''].join('|'),
	hookDeps: (slug, { queryParams: { share, skip } }) => [slug, share, skip],
	errorHandler: pageDataErrorHandler<PsfSharePageDataErrorCode>(),
});
